var map = {
	"./bolhas.jpg": "mQo6",
	"./eclipse.svg": "oNt2",
	"./eu.jpg": "iWJT",
	"./projects/agentega.png": "QaNs",
	"./projects/ambulatilis.jpg": "tbit",
	"./projects/anota.png": "UnAJ",
	"./projects/campusparty.png": "/arX",
	"./projects/cgpdt.png": "MHBj",
	"./projects/cliptopia.png": "zMvh",
	"./projects/comissaoarns.png": "/GIg",
	"./projects/copar.png": "Xk8m",
	"./projects/cryptoqubes.png": "KmCf",
	"./projects/cuidando.jpg": "XYOB",
	"./projects/digitalrights.png": "4T3n",
	"./projects/direitossilencios.png": "lBFc",
	"./projects/dl.png": "8/JV",
	"./projects/ethermap.jpg": "/S9I",
	"./projects/etherplant.png": "eXRh",
	"./projects/isofia.jpg": "2e0x",
	"./projects/labmacambira.png": "fAbB",
	"./projects/labyrimental.jpg": "W4nW",
	"./projects/leggo.png": "gWkI",
	"./projects/mapinguari.png": "SVK3",
	"./projects/monitorando.jpg": "5UMh",
	"./projects/odd.svg": "pl+U",
	"./projects/radar.png": "Hp2v",
	"./projects/samia.jpg": "wYkA",
	"./projects/secom.png": "t5Cm",
	"./projects/seminariocamara.svg": "aU2T",
	"./projects/trazdia.png": "G6aX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s52u";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails ^\.\/.*$
// module id = s52u
// module chunks = 0